import { call, put, select, takeLatest } from "redux-saga/effects";
import { fetchSegments } from "../../../services/accIqService";
import { FETCH_SEGMENTS_REQUEST, fetchSegmentsFailure, fetchSegmentsSuccess } from "../actions/segmentsActions";
// Worker Saga
function* fetchSegmentsSaga() {
  try {
    const params = yield select(state=>state?.segmentsReducer?.payload);
    const {accountName}  = params;
    const data = yield call(fetchSegments,accountName);
    yield put(fetchSegmentsSuccess(data));
  } catch (error) {
    yield put(fetchSegmentsFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchSegments() {
  yield takeLatest(FETCH_SEGMENTS_REQUEST, fetchSegmentsSaga);
}
